<template>
  <v-snackbar v-model="isVisible" :timeout="snackbar.timeout ?? 5000" bottom>
    <span v-html="sanitizedContent">"sanitizedContent"</span>

    <v-btn color="primary" text small class="ml-14" variant="text" @click="closeSnackbar">
      Cerrar
    </v-btn>
  </v-snackbar>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: 'VSnackBar',
  props: ['snackbar'],

  computed: {
    isVisible: {
      get() {
        return this.snackbar.visible;
      },
      set(value) {
        if (!value) {
          this.closeSnackbar();
        }
      }
    },
    // Nueva propiedad para limpiar el contenido antes de mostrarlo
    sanitizedContent() {
      if (!this.snackbar.content) return '';
      
      // Sanitiza el contenido eliminando etiquetas peligrosas (scripts, event handlers, etc.)
      return DOMPurify.sanitize(this.snackbar.content);
    }
  },

  methods: {
    closeSnackbar() {
      this.$store.dispatch('notifications/closeSnackbar');
    },
  },
};
</script>